export const MY_FAVORITES_STARTED = 'MY_FAVORITES_STARTED';
export const MY_FAVORITES_SUCCESS = 'MY_FAVORITES_SUCCESS';
export const MY_FAVORITES_FAILURE = 'MY_FAVORITES_FAILURE';

export const REMOVE_FROM_FAVORITES_STARTED = 'REMOVE_FROM_FAVORITES_STARTED';
export const REMOVE_FROM_FAVORITES_SUCCESS = 'REMOVE_FROM_FAVORITES_SUCCESS';
export const REMOVE_FROM_FAVORITES_FAILURE = 'REMOVE_FROM_FAVORITES_FAILURE';